module.exports = __webpack_public_path__ + "assets/5d6e3a5d8d8856a31ed12eb49fdff5c2.png";